import JnexId from './JnexId';


export default JnexId;
